import { useContext } from "react";
import Paragraph from "../../../../elements/p/Paragraph";
import { VscClose } from "react-icons/vsc";
import searchContext from "../../../../../dataManager/context/searchContext";
import { MAX_PRISE } from "../../../../../datas/constantsValues";

const PlaceholderNoFilterProduct = () => {
  const { resetAllSearch } = useContext(searchContext);
  return (
    <div
      onClick={() => resetAllSearch()}
      className="animate group flex cursor-pointer flex-col items-center justify-center rounded border border-dashed border-secondary bg-smoot p-3 hover:bg-primary"
    >
      <VscClose className="animate font-nunito text-5xl font-bold text-secondary group-hover:text-smoot" />
      <h3 className="font-nunito text-sm font-semibold text-secondary">
        Aucun article trouvé
      </h3>
      <Paragraph size="small" classe="text-center mt-1">
        Cliquez ici pour annuler la récherhe
      </Paragraph>
    </div>
  );
};

export default PlaceholderNoFilterProduct;
